<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-img :src="topics[0].image" class="image"></v-img>
        <div class="after-image">{{ topics[0].text }}</div>
        <h2>
          Our <linkto text="Denver" to="/location/denver"></linkto> Roofers
          Respect Your Home & Family
        </h2>
        <p>
          <linkto text="AquaDuct Roof and Gutters" to="/"></linkto> provides new
          roofing and roof replacement for homes of any size. Our commitment to
          superior customer service is what sets us apart from other
          <linkto
            text="Colorado Springs"
            to="/location/coloradosprings"
          ></linkto>
          roofing companies, so we’ll do your job efficiently and with as little
          disruption to your routine as possible. In fact, most projects are
          completed within a day or two, and we are happy to work around your
          schedule.
        </p>
        <p>
          Our roofers take great care to protect your lawn and landscaping
          during a roofing project. We’ll place tarps to keep discarded roofing
          material from hitting windows and doors, and falling on delicate
          trees, bushes and flowers. Once the work is finished, we’ll use a
          special magnet to remove stray nails and roofing materials so your
          lawn will once again be safe for your family and pets. Trust the
          professionals of AquaDuct Roof and Gutters to do the job right, the
          first time.
        </p>
        <h2>Top-Quality Materials for Roof Replacement & Repairs</h2>
        <p>
          Colorado Springs roofing is a sizable investment, so it only makes
          sense to utilize the best products available to replace your roof. At
          AquaDuct, we don’t believe in skimping on materials, which is why we
          utilize the premier brands in the roofing industry: Owens Corning,
          CertainTeed, GAF and TAMKO. The materials we use for roofing Colorado
          Springs homes are typically engineered to last for several decades,
          ensuring the maximum amount of service life and long-lasting curb
          appeal.
        </p>
        <h2>BBB Gold Star Award Winner</h2>
        <p>
          Recipients of the Better Business Bureau’s Gold Star Award have
          achieved an outstanding record of customer service for three
          consecutive years. To qualify, Denver roofers must have no customer
          complaints filed during that time period. AquaDuct has earned this
          award five years in a row! One year with no complaints is a difficult
          feat in any industry, so we’re especially proud of this achievement.
        </p>
        <h2>Get a Free Estimage for Roofing Your Home!</h2>
        <p>
          To schedule a FREE estimate for roofing your Colorado Springs home,
          call
          <linkto text="AquaDuct Roof and Gutters" to="/"></linkto> anytime. For
          more information on our service areas, including
          <linkto text="Denver" to="/location/denver"></linkto>,
          <linkto
            text="Colorado Springs"
            to="/location/coloradosprings"
          ></linkto
          >, <linkto text="Peyton" to="/location/peyton"></linkto>,
          <linkto text="Castle Rock" to="/castlerock"></linkto>
          and <linkto text="Pueblo" to="/location/pueblo"></linkto>, kindly
          visit our <linkto text="Contact Us" to="/contact"></linkto> page. Not
          certain whether you need a new roof? That’s OK too – we’re the roofing
          contractors Denver homeowners turn to for honest, dependable advice.
          We’ll conduct a thorough inspection of your roof and explain our
          findings in detail. Contact AquaDuct today at
          <phonenumber phone="(719) 390-7663"></phonenumber>
        </p>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
        <!-- <guild></guild> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import router from "@/_router/index";
// import guild from "@/components/controls/GuildQuality";
import linkto from "@/components/controls/link-to";
import TopicService from "@/_services/topic-service";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "roofing-home",

  components: {
    estimate,
    // guild,
    linkto,
    phonenumber,
  },

  created() {
    this.topics = TopicService.getTopics();
  },

  data: () => ({
    height: 300,
    width: 675,
    topics: [],
  }),

  methods: {
    onAbout() {
      router.push("/about/home");
    },
  },
};
</script>

<style lang="scss" scoped>
.after-image {
  margin-top: 20px;
  margin-bottom: 20px;
}

.subtitle-span {
  background: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  float: left;
}
</style>
